import { useContext, useState, useEffect, ChangeEvent } from 'react';
import { WorkflowContext } from "../../context/WorkflowContextProvider";
import {
    Select,
    Switch,
    MenuItem
} from '@mui/material';
import { workflowSettingsHelperText } from "../forms/components/defaults/defaults";
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { dataStoresOptions } from "../forms/components/defaults/defaults";

export const WorkflowSettingsPanel = () => {
    const context = useContext(WorkflowContext);

    const [memoryToggle, setMemoryToggle] = useState<boolean>(false);
    const [exitOnErrorToggle, setExitOnErrorToggle] = useState<boolean>(true);
    const [dataStore, setDataStore] = useState<string>('messages');

    function handleLongTermMemoryChange(event: ChangeEvent<HTMLInputElement>): void {
        console.log(event.target.checked);
        setMemoryToggle(event.target.checked)
        context.updateSetting('memory', event.target.checked)
    }

    function handleExitOnErrorChange(event: ChangeEvent<HTMLInputElement>): void {
        console.log(event.target.checked);
        setExitOnErrorToggle(event.target.checked)
        context.updateSetting('error_exit', event.target.checked)
    }

    function handleDefaultExitValueChange(event: ChangeEvent<HTMLInputElement>): void {
        console.log(event.target.checked);
        setDataStore(event.target.value);
        context.updateSetting('default_exit', event.target.value)
    }

    useEffect( () => {
        if (context !== undefined) {
            // debugger;
            const settings = context.settings;
            if (settings !== undefined && typeof settings.memory === "boolean") {
                setMemoryToggle(settings.memory);
            }
            if (settings !== undefined && typeof settings.error_exit === "boolean") {
                setExitOnErrorToggle(settings.error_exit);
            }
            if (settings !== undefined && typeof settings.default_exit === 'string' && settings.default_exit.length > 0) {
                setDataStore(settings.default_exit);
            }
        }

    }, [context] );

    return (
        <div className="workflow-settings__top">
            <span className="top__title" >{ "Workflow Settings" }</span>
            <div className="settings">
                <div className="settings__item">
                    <span>{ 'Enable Long Term Memory' }</span>
                    <Switch value={ memoryToggle }
                            checked={ memoryToggle }
                            onChange={ handleLongTermMemoryChange } />
                    <div className="settings__helper">
                        <div className="helper__icon" >
                            <QuestionMarkIcon />
                        </div>
                        <div className="helper__text">
                            <pre>{ workflowSettingsHelperText['memory'] }</pre>
                        </div>
                    </div>
                </div>
                <div className="settings__item">
                    <span>{ 'Exit Workflow On Error' }</span>
                    <Switch value={exitOnErrorToggle}
                            checked={ exitOnErrorToggle }
                            onChange={ handleExitOnErrorChange } />
                    <div className="settings__helper">
                        <div className="helper__icon" >
                            <QuestionMarkIcon />
                        </div>
                        <div className="helper__text">
                            <pre>{ workflowSettingsHelperText['error_exit'] }</pre>
                        </div>
                    </div>
                </div>
                <div className="settings__item">
                    <div className="item__stack">
                        <span>{ "Override default exit data location" }</span>
                        <Select value={ dataStore }
                                name="data-store-select"
                                onChange={ handleDefaultExitValueChange } >
                            { dataStoresOptions.map( (store: { id: string, value: string }, index : number) => (
                                <MenuItem key={ 'data_store_item_' + index  }  value={ store.id }>{ store.value }</MenuItem>
                            ) ) }
                            <MenuItem value="data_to_loop">{ "Loop Data Slot (only works in loops)" }</MenuItem>
                            <MenuItem value="latest_user_message">{ "Lastest User Message" }</MenuItem>
                            <MenuItem value="messages">{ "Messages" }</MenuItem>
                        </Select>
                    </div>

                    <div className="settings__helper">
                        <div className="helper__icon" >
                            <QuestionMarkIcon />
                        </div>
                        <div className="helper__text">
                            <pre>{ workflowSettingsHelperText['default_exit'] }</pre>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}